const guia = {
  hero: {
    badge: 'Inteligencia de Mercado',
    title1: 'Guía de Precios por',
    title2: ' Barrio y Ciudad 2025',
    description: 'Comprenda los valores del mercado local con precio medio por m² / sq ft, tendencias año a año y puntuaciones de barrios en Miami (Florida, EE.UU.), São Paulo y Brasília.',
    statCities: '3 Ciudades',
    statNeighborhoods: '20 Barrios',
    statTrends: 'Tendencias 5 Años',
    statAi: 'Datos Generados por IA',
  },
  pulse: {
    title: 'Pulso del Mercado',
    subtitle: '3 mercados · Últimas actualizaciones',
    updated: 'Actualizado el',
    viewGuide: 'Ver guía',
    recentUpdates: 'actualizaciones recientes',
    badgePrices: 'Precios',
    badgeTrend: 'Tendencia',
    disclaimer: '<0>Solo con Fines Educativos — Aviso sobre Datos Generados por IA:</0> Las cifras de precio medio por m² / sq ft, tasas de crecimiento interanual y puntuaciones de barrios presentadas en esta página son estimaciones generadas por IA, recopiladas a partir de informes de mercado disponibles públicamente, índices inmobiliarios (FipeZAP, ZAP Imóveis, CondoBlackBook) y fuentes de terceros de 2024–2025. Estos datos pueden estar desactualizados, incompletos o ser inexactos. Están destinados exclusivamente a fines educativos e informativos generales y no constituyen asesoramiento financiero, de inversión o inmobiliario. <1>Carvalho\'s Imobiliária no asume ninguna responsabilidad por errores, omisiones o decisiones tomadas con base en esta información.</1> Consulte siempre a un profesional inmobiliario autorizado y realice una debida diligencia independiente antes de tomar cualquier decisión de inversión.',
  },
  citySelector: {
    title: 'Seleccione una Ciudad',
    subtitle: 'Haga clic para explorar barrios y datos de precios',
    selected: 'Seleccionado',
    listings: 'inmuebles',
    avgPrice: 'Precio medio',
    yoyGrowth: 'Crec. anual',
    viewFullGuide: 'Ver guía completa de',
  },
  miamiDetail: {
    description: 'Miami es uno de los mercados inmobiliarios de lujo más dinámicos del mundo, atrayendo a inversores internacionales y compradores de ultra alto poder adquisitivo. La ciudad combina estilo de vida tropical, comodidades de clase mundial y un fuerte potencial de apreciación. En 2025, los precios de los condominios de lujo superaron los $1,000/sq ft en promedio por primera vez en la historia.',
    avgPrice: 'Precio Medio',
    yoyGrowth: 'Crec. Anual',
    neighborhoods: 'Barrios',
    activeListings: 'Inmuebles Activos',
    priceEvolution: 'Evolución del Precio Medio',
    since2020: '+54.5% desde 2020',
    currentAvg: 'Media actual (2025)',
    neighborhoodsTitle: 'Barrios de Miami',
    neighborhoodsFound: '7 barrios encontrados',
    searchPlaceholder: 'Buscar barrios...',
    sortPrice: 'Precio',
    sortGrowth: 'Crecimiento',
    sortAZ: 'A–Z',
    pricePerSqft: 'Precio medio por sq ft',
    yoyVar: 'Var. anual',
    walkability: 'Caminabilidad',
    infrastructure: 'Infraestructura',
    appreciation: 'Valorización',
    viewFullGuide: 'Ver Guía Completa',
  },
  priceTable: {
    title: 'Comparativa Completa de Precios',
    subtitle: 'Todos los barrios ordenados por precio medio por unidad',
    colNeighborhood: 'Barrio',
    colCity: 'Ciudad',
    colAvgPrice: 'Precio Medio',
    colYoY: 'Var. Anual',
    colMarketType: 'Tipo de Mercado',
    colListings: 'Inmuebles',
  },
  compare: {
    title: 'Herramienta Interactiva',
    subtitle: 'Compare mercados lado a lado',
    description: 'Seleccione dos mercados y compare precios, yield, puntuaciones de inversión y perfil ideal.',
    marketA: 'Mercado A',
    marketB: 'Mercado B',
    metric: 'Métrica',
    overview: 'Visión General',
    returnYield: 'Retorno y Yield',
    investmentScores: 'Puntuaciones de Inversión (0–10)',
    overallScore: 'Puntuación General',
    profileAnalysis: 'Perfil y Análisis',
    strengths: 'Puntos fuertes',
    risks: 'Riesgos principales',
    viewAnalysis: 'Ver análisis completo por barrio',
    viewMiamiGuide: 'Ver guía de Miami',
    viewSPGuide: 'Ver guía de São Paulo',
    footerNote: 'Las puntuaciones son estimaciones editoriales basadas en índices públicos (FipeZAP, Zillow, Q1 2025). No constituyen asesoramiento financiero.',
    of10: 'de 10',
    currency: 'Moneda',
    entryPrice: 'Precio de entrada (mín.)',
    avgPrice: 'Precio medio',
    topMarket: 'Tope de mercado',
    yoyAppreciation: 'Valorización interanual',
    rentalYield: 'Rendimiento de alquiler',
    recommendedHorizon: 'Horizonte recomendado',
    marketLiquidity: 'Liquidez de mercado',
    appreciationPotential: 'Potencial de valorización',
    passiveIncome: 'Ingreso pasivo',
    idealProfile: 'Perfil ideal del inversor',
    locationMiami: 'Florida, EE.UU.',
    locationSP: 'São Paulo, Brasil',
    currencyA: 'USD · Dólar estadounidense',
    currencyB: 'BRL · Real brasileño',
    yieldA: '5–8% anual',
    yieldB: '4–6% anual',
    horizonA: '5–10 años',
    horizonB: '3–10 años',
    idealProfileA: 'Diversificación internacional, protección cambiaria y horizonte a largo plazo (5–10 años)',
    idealProfileB: 'Máxima liquidez, diversidad de barrios y exposición al mayor hub financiero de América Latina',
    strengthsA: ['0% impuesto estatal FL', 'Alquiler a corto plazo viable', 'Mercado internacional', 'Cobertura cambiaria BRL/USD', 'Valorización acumulada +54% (5 años)'],
    strengthsB: ['Mayor mercado de LATAM', 'Máxima liquidez', 'Diversidad de barrios y rangos', 'Hub corporativo Faria Lima'],
    risksA: ['Riesgo cambiario (BRL/USD)', 'Altos costos de mantenimiento', 'Seguros obligatorios (huracanes)', 'Burocracia para no residentes'],
    risksB: ['ITBI + alta carga tributaria', 'Alta oferta en algunos barrios', 'Valorización más gradual'],
  },
  country: {
    usa: 'EE.UU.',
    brazil: 'Brasil',
  },
  cta: {
    title: '¿Listo para invertir en el barrio adecuado?',
    specialist: 'Especialista en Inteligencia de Mercado',
    description: 'Nuestros especialistas conocen cada mercado al dedillo. Reciba asesoría personalizada hoy.',
    whatsapp: 'Hablar con un Experto por WhatsApp',
    browse: 'Ver Todos los Inmuebles',
  },
  spHighlight: {
    title: 'Itaim Bibi lidera la valorización en SP con +11.3% interanual en T1 2026',
    subtitle: 'El eje Faria Lima mantiene una demanda alta con nuevas oficinas de fondos internacionales en la región.',
  },
  brasiliaHighlight: {
    title: 'FipeZAP: DF lidera la valorización entre capitales con +12.6% en 2025',
    subtitle: 'Sudoeste y Noroeste impulsan la subida — el precio medio en Plano Piloto alcanza R$14,300/m².',
  },
  miamiHighlight: {
    title: 'Sunny Isles supera los US$2,000/sq ft por primera vez en la historia',
    subtitle: 'Bentley Residences y Porsche Design Tower elevan el piso de precios de la región a un récord histórico.',
  },
  cityPages: {
    shared: {
      marketPulse: 'Market Pulse',
      updates: '3 actualizaciones',
      updatedOn: 'Actualizado el',
      disclaimerWarning: 'Aviso',
      disclaimerMiami: 'Los datos de precios son estimaciones basadas en índices públicos (CondoBlackBook, Zillow, Q1 2025). No constituyen asesoramiento financiero. Consulte a un profesional antes de tomar cualquier decisión de inversión.',
      disclaimerBR: 'Los datos de precios son estimaciones basadas en índices públicos (FipeZAP, ZAP Imóveis, 2025). No constituyen asesoramiento financiero. Consulte a un profesional antes de tomar cualquier decisión de inversión.',
      interactiveTool: 'Herramienta interactiva',
      compareHeading: 'Compare mercados lado a lado',
      compareSubtitle: 'Seleccione dos mercados y compare precios, yield, puntuaciones de inversión y perfil ideal.',
      marketA: 'Mercado A',
      marketB: 'Mercado B',
      vs: 'VS',
      metric: 'Métrica',
      overview: 'Visión general',
      returnYield: 'Retorno y yield',
      investmentScores: 'Puntuaciones de inversión (0–10)',
      overallScore: 'Puntuación general',
      profileAnalysis: 'Perfil y análisis',
      idealProfile: 'Perfil ideal del inversor',
      strengths: 'Puntos fuertes',
      risks: 'Riesgos principales',
      viewAnalysis: 'Ver análisis completo por barrio',
      footerNote: 'Las puntuaciones son estimaciones editoriales basadas en índices públicos (FipeZAP, Zillow, Q1 2025). No constituyen asesoramiento financiero.',
      of10: 'de 10',
      currency: 'Moneda',
      entryPrice: 'Precio de entrada (mín.)',
      avgPrice: 'Precio medio',
      topMarket: 'Tope de mercado',
      yoyAppreciation: 'Valorización interanual',
      rentalYield: 'Rendimiento de alquiler',
      recommendedHorizon: 'Horizonte recomendado',
      marketLiquidity: 'Liquidez de mercado',
      appreciationPotential: 'Potencial de valorización',
      passiveIncome: 'Ingreso pasivo',
      faqBadge: 'Preguntas frecuentes',
      viewAllFaqs: 'Ver todas las preguntas en el centro de FAQ',
      exploreBadge: 'Market Guide',
      exploreTitle: 'Explore otros mercados',
      exploreSubtitle: 'Análisis detallado de los principales destinos de inversión inmobiliaria.',
      exploreViewAll: 'Ver todos los mercados',
      avgPriceLabel: 'Precio medio',
      yoyLabel: 'Valorización interanual',
      viewFullGuide: 'Ver guía completa',
      colRank: '#',
      colNeighborhood: 'Barrio',
      colPrice: 'Precio medio',
      colYoY: 'Var. anual',
      colProfile: 'Perfil',
      colListings: 'Inmuebles',
      hot: 'Hot',
      top: 'Top',
      currencyLabel: 'Moneda',
      ctaWhatsapp: 'Hablar con un experto ahora',
      falarConsultor: 'Hablar con un consultor',
    },
    miami: {
      heroBadge: 'Miami · Florida',
      heroTitle: 'Mejores barrios de Miami',
      heroTitleHighlight: 'para invertir en 2025',
      heroDescription: 'Miami se ha consolidado como el principal destino de inversión inmobiliaria para los brasileños en Estados Unidos. Con precios medios superiores a $1,000/sq ft, valorización histórica de dos dígitos y sin impuesto estatal sobre la renta, la ciudad ofrece uno de los mejores rendimientos ajustados al riesgo del mundo.',
      heroCtaProperties: 'Ver inmuebles en Miami',
      heroCtaContact: 'Hablar con un consultor',
      location: 'Miami, FL',
      countryLabel: 'Florida, EE.UU.',
      currencyA: 'USD · Dólar estadounidense',
      currencyB: 'BRL · Real brasileño',
      strengthsA: ['0% impuesto estatal FL', 'Alquiler a corto plazo viable', 'Mercado internacional', 'Cobertura cambiaria BRL/USD', 'Valorización acumulada +54% (5 años)'],
      strengthsB: ['Mayor mercado de LATAM', 'Máxima liquidez', 'Diversidad de barrios y rangos', 'Hub corporativo Faria Lima'],
      risksA: ['Riesgo cambiario (BRL/USD)', 'Altos costos de mantenimiento', 'Seguros obligatorios (huracanes)', 'Burocracia para no residentes'],
      risksB: ['ITBI + alta carga tributaria', 'Alta oferta en algunos barrios', 'Valorización más gradual'],
      idealProfileA: 'Diversificación internacional, protección cambiaria y horizonte a largo plazo (5–10 años)',
      idealProfileB: 'Máxima liquidez, diversidad de barrios y exposición al mayor hub financiero de América Latina',
      entryPriceA: 'US$ 400.000',
      entryPriceB: 'R$ 350.000',
      avgPriceA: 'US$ 1.100/sq ft',
      avgPriceB: 'R$ 11.800/m²',
      topMarketA: 'US$ 3.800/sq ft · Bal Harbour',
      topMarketB: 'R$ 32.000/m² · Cidade Jardim',
      yieldA: '5–8% anual',
      yieldB: '4–6% anual',
      horizonA: '5–10 años',
      horizonB: '3–10 años',
      liquidityA: '9.2',
      liquidityB: '10.0',
      appreciationA: '9.0',
      appreciationB: '7.0',
      passiveIncomeA: '8.0',
      passiveIncomeB: '7.0',
      overallScoreA: '8.7',
      overallScoreB: '8.0',
      scoreWidthA: '87%',
      scoreWidthB: '80%',
      viewGuideA: 'Ver guía de Miami',
      viewGuideB: 'Ver guía de São Paulo',
      whyInvestTitle: '¿Por qué invertir en Miami?',
      whyInvestSubtitle: '4 razones que hacen de Miami el mayor destino de inversión inmobiliaria para brasileños en EE.UU.',
      neighborhoodsTitle: 'Barrios de Miami — Análisis completo',
      neighborhoodsSubtitle: 'Haga clic en cualquier barrio para ver precios detallados, puntuaciones y destacados del mercado.',
      rankingTitle: 'Ranking de precios — Barrios de Miami',
      rankingSubtitle: 'Comparativa ordenada por precio medio por sq ft · Q1 2025',
      howToBuyBadge: 'Guía para brasileños',
      howToBuyTitle: 'Cómo comprar inmueble en Miami siendo brasileño',
      howToBuySubtitle: 'Guía paso a paso para inversores brasileños que desean adquirir inmuebles en EE.UU. con seguridad jurídica y eficiencia fiscal.',
      howToBuyHelpTitle: '¿Necesita ayuda con todo este proceso?',
      howToBuyHelpSubtitle: 'Nuestro equipo orienta a brasileños desde el ITIN hasta la entrega de llaves — sin costo adicional.',
      howToBuyHelpCTA: 'Hablar con un especialista',
      faqTitle: 'Preguntas sobre invertir en Miami',
      faqSubtitle: 'Principales dudas de inversores brasileños sobre la compra de inmuebles en Miami — respondidas por especialistas.',
      exploreCardBrasiliaTitle: 'Brasília',
      exploreCardBrasiliaSubtitle: 'Capital federal con mayor renta per cápita de Brasil, patrimonio UNESCO y mercado resiliente.',
      exploreCardBrasiliaBadge: 'Distrito Federal',
      exploreCardBrasiliaPrice: 'R$12.000/m²',
      exploreCardBrasiliaYoY: '+12,6%',
      exploreCardBrasiliaYoYLabel: 'Mayor alza del año',
      exploreCardSPTitle: 'São Paulo',
      exploreCardSPSubtitle: 'Mayor mercado inmobiliario de América Latina. Faria Lima, Itaim Bibi y el eje de valorización continua.',
      exploreCardSPBadge: 'São Paulo, Brasil',
      exploreCardSPPrice: 'R$11.800/m²',
      exploreCardSPYoY: '+8,7%',
      exploreCardSPYoYLabel: 'Valorización interanual',
      ctaTitle: '¿Listo para invertir en Miami?',
      ctaSubtitle: 'Nuestro equipo especializado en inmuebles de Miami atiende a brasileños desde hace más de 9 años. Del ITIN a la entrega de llaves.',
      ctaSecondary: 'Ver inmuebles en Miami',
    },
    saoPaulo: {
      heroBadge: 'São Paulo · SP',
      heroTitle: 'Mejores barrios de São Paulo',
      heroTitleHighlight: 'para invertir en 2025',
      heroDescription: 'São Paulo es la capital financiera de Brasil y el mayor mercado inmobiliario de América Latina. Con más de 12 millones de habitantes, un PIB equivalente al de países enteros y una valorización media del +8,7% en 2025, la ciudad ofrece oportunidades únicas para inversores que buscan renta, valorización o diversificación patrimonial.',
      heroCtaProperties: 'Ver inmuebles en São Paulo',
      heroCtaContact: 'Hablar con un consultor',
      location: 'São Paulo, SP',
      countryLabel: 'São Paulo, Brasil',
      currencyA: 'BRL · Real brasileño',
      currencyB: 'USD · Dólar estadounidense',
      strengthsA: ['Mayor mercado de LATAM', 'Máxima liquidez', 'Diversidad de barrios y rangos', 'Hub corporativo Faria Lima'],
      strengthsB: ['0% impuesto estatal FL', 'Alquiler a corto plazo viable', 'Mercado internacional', 'Cobertura cambiaria BRL/USD', 'Valorización acumulada +54% (5 años)'],
      risksA: ['ITBI + alta carga tributaria', 'Alta oferta en algunos barrios', 'Valorización más gradual'],
      risksB: ['Riesgo cambiario (BRL/USD)', 'Altos costos de mantenimiento', 'Seguros obligatorios (huracanes)', 'Burocracia para no residentes'],
      idealProfileA: 'Máxima liquidez, diversidad de barrios y exposición al mayor hub financiero de América Latina',
      idealProfileB: 'Diversificación internacional, protección cambiaria y horizonte a largo plazo (5–10 años)',
      entryPriceA: 'R$ 350.000',
      entryPriceB: 'US$ 400.000',
      avgPriceA: 'R$ 11.800/m²',
      avgPriceB: 'US$ 1.100/sq ft',
      topMarketA: 'R$ 32.000/m² · Cidade Jardim',
      topMarketB: 'US$ 3.800/sq ft · Bal Harbour',
      yieldA: '4–6% anual',
      yieldB: '5–8% anual',
      horizonA: '3–10 años',
      horizonB: '5–10 años',
      liquidityA: '10.0',
      liquidityB: '9.2',
      appreciationA: '7.0',
      appreciationB: '9.0',
      passiveIncomeA: '7.0',
      passiveIncomeB: '8.0',
      overallScoreA: '8.0',
      overallScoreB: '8.7',
      scoreWidthA: '80%',
      scoreWidthB: '87%',
      viewGuideA: 'Ver guía de São Paulo',
      viewGuideB: 'Ver guía de Miami',
      whyInvestTitle: '¿Por qué invertir en São Paulo?',
      whyInvestSubtitle: '4 razones que hacen de São Paulo el mayor destino de inversión inmobiliaria de América Latina.',
      neighborhoodsTitle: 'Barrios de São Paulo — Análisis completo',
      neighborhoodsSubtitle: 'Haga clic en cualquier barrio para ver precios detallados, puntuaciones y perfil del mercado.',
      rankingTitle: 'Ranking de precios — Barrios de São Paulo',
      rankingSubtitle: 'Comparativa ordenada por precio medio por m² · 2025',
      faqTitle: 'Preguntas sobre inmuebles en São Paulo',
      faqSubtitle: 'Principales dudas de compradores e inversores sobre el mayor mercado inmobiliario de América Latina.',
      exploreCardMiamiTitle: 'Miami',
      exploreCardMiamiSubtitle: 'El principal destino de los brasileños en EE.UU. — dólar fuerte, alto rendimiento y mercado internacional.',
      exploreCardMiamiBadge: 'Florida, EE.UU.',
      exploreCardMiamiPrice: '$1.100/sq ft',
      exploreCardMiamiYoY: '+18%',
      exploreCardMiamiYoYLabel: 'Valorización interanual',
      exploreCardBrasiliaTitle: 'Brasília',
      exploreCardBrasiliaSubtitle: 'Capital federal con mayor renta per cápita de Brasil, patrimonio UNESCO y mercado resiliente.',
      exploreCardBrasiliaBadge: 'Distrito Federal',
      exploreCardBrasiliaPrice: 'R$12.000/m²',
      exploreCardBrasiliaYoY: '+12,6%',
      exploreCardBrasiliaYoYLabel: 'Mayor alza del año',
      ctaTitle: '¿Listo para invertir en São Paulo?',
      ctaSubtitle: 'Nuestro equipo especializado en el mercado paulistano lo orienta desde la elección del barrio hasta la firma del contrato — sin costo adicional.',
      ctaSecondary: 'Ver inmuebles en São Paulo',
    },
    brasilia: {
      heroBadge: 'Brasília · Distrito Federal',
      heroTitle: 'Mejores barrios de Brasília',
      heroTitleHighlight: 'para comprar inmueble en 2025',
      heroDescription: 'Brasília registró un crecimiento del 12,6% en los precios de inmuebles nuevos en 2025 — el mayor entre las capitales brasileñas. Capital federal con una de las rentas per cápita más altas de Brasil, demanda pública estable y oferta naturalmente restringida por la protección urbanística, la ciudad es uno de los mercados más resilientes del país.',
      heroCtaProperties: 'Ver inmuebles en Brasília',
      heroCtaContact: 'Hablar con un consultor',
      location: 'Brasília, DF',
      countryLabel: 'Distrito Federal, Brasil',
      currencyA: 'BRL · Real brasileño',
      currencyB: 'BRL · Real brasileño',
      strengthsA: ['Oferta limitada por UNESCO', 'Mayor renta per cápita de BR', 'Demanda pública estable', 'Mercado resiliente en crisis'],
      strengthsB: ['Mayor mercado de LATAM', 'Máxima liquidez', 'Diversidad de barrios y rangos', 'Hub corporativo Faria Lima'],
      risksA: ['Liquidez más regional', 'Dependencia de presupuestos federales', 'Mercado menos diversificado'],
      risksB: ['ITBI + alta carga tributaria', 'Alta oferta en algunos barrios', 'Valorización más gradual'],
      idealProfileA: 'Perfil conservador que busca seguridad patrimonial e ingresos estables de servidores públicos',
      idealProfileB: 'Máxima liquidez, diversidad de barrios y exposición al mayor hub financiero de América Latina',
      entryPriceA: 'R$ 450.000',
      entryPriceB: 'R$ 350.000',
      avgPriceA: 'R$ 12.000/m²',
      avgPriceB: 'R$ 11.800/m²',
      topMarketA: 'R$ 16.500/m² · Sudoeste',
      topMarketB: 'R$ 32.000/m² · Cidade Jardim',
      yieldA: '~5% anual',
      yieldB: '4–6% anual',
      horizonA: '3–7 años',
      horizonB: '3–10 años',
      liquidityA: '7.0',
      liquidityB: '10.0',
      appreciationA: '8.0',
      appreciationB: '7.0',
      passiveIncomeA: '7.0',
      passiveIncomeB: '7.0',
      overallScoreA: '7.3',
      overallScoreB: '8.0',
      scoreWidthA: '73%',
      scoreWidthB: '80%',
      viewGuideA: 'Ver guía de Brasília',
      viewGuideB: 'Ver guía de São Paulo',
      whyInvestTitle: '¿Por qué invertir en Brasília?',
      whyInvestSubtitle: '4 factores estructurales que hacen de Brasília uno de los mercados inmobiliarios más resilientes de Brasil.',
      neighborhoodsTitle: 'Barrios de Brasília — Análisis completo',
      neighborhoodsSubtitle: 'Haga clic en cualquier barrio para ver precios detallados, puntuaciones y perfil del mercado.',
      rankingTitle: 'Ranking de precios — Barrios de Brasília',
      rankingSubtitle: 'Comparativa ordenada por precio medio por m² · 2025',
      faqTitle: 'Preguntas sobre inmuebles en Brasília',
      faqSubtitle: 'Principales dudas de compradores e inversores sobre el mercado inmobiliario de Brasília y el Distrito Federal.',
      exploreCardMiamiTitle: 'Miami',
      exploreCardMiamiSubtitle: 'El principal destino de los brasileños en EE.UU. — dólar fuerte, alto rendimiento y mercado internacional.',
      exploreCardMiamiBadge: 'Florida, EE.UU.',
      exploreCardMiamiPrice: '$1.100/sq ft',
      exploreCardMiamiYoY: '+18%',
      exploreCardMiamiYoYLabel: 'Valorización interanual',
      exploreCardSPTitle: 'São Paulo',
      exploreCardSPSubtitle: 'Mayor mercado inmobiliario de América Latina. Faria Lima, Itaim Bibi y el eje de valorización continua.',
      exploreCardSPBadge: 'São Paulo, Brasil',
      exploreCardSPPrice: 'R$11.800/m²',
      exploreCardSPYoY: '+8,7%',
      exploreCardSPYoYLabel: 'Valorización interanual',
      ctaTitle: '¿Listo para invertir en Brasília?',
      ctaSubtitle: 'Nuestro equipo especializado en el mercado del DF lo orienta desde la elección del barrio hasta la firma del contrato — sin costo adicional.',
      ctaSecondary: 'Ver inmuebles en Brasília',
    },
  },
};

export default guia;